import type { EntradaStatus } from '@/components/Gestores/gestorClienteEntradaConfig'

export function buildGestoresEntradasReturnQuery(input: {
  status: EntradaStatus
  search: string
}) {
  const params = new URLSearchParams()
  params.set('tab', 'entradas')
  params.set('entStatus', input.status)
  if (input.search.trim()) params.set('entSearch', input.search.trim())
  return params.toString()
}
